import { API_URL } from './constants';
import { fetchJson } from './dataProvider/dataProvider';
import { authProvider } from './authProvider';

export const logEvent = (
  eventName: string,
  data: Record<string, any> = {}
): void => {
  try {
    if (!eventName) {
      return;
    }
    const currentUser = authProvider.getCurrentUser();
    if (currentUser) {
      data.idp_user_id = currentUser.uid;
    }
    void fetchJson(`${API_URL}/events`, {
      method: 'POST',
      body: JSON.stringify({
        name: eventName,
        location: window.location.href,
        data: data || undefined,
      }),
      keepalive: true,
    });
  } catch (e) {
    console.error('log event failed', e);
  }
};
